import styled from "styled-components";
import PinIc from "_c/icon/Pin";

export const Wrap = styled.div`
  @media (max-width: 1191px) {
    margin-left: 15px;
  }
  @media (max-width: 991px) {
    margin-left: 0;
  }
`;
export const ReviewsSect = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
  img {
    width: 40px;
    margin-right: 5px;
    @media (max-width: 991px) {
      position: relative;
      top: 4px;
    }
  }
`;
export const Average = styled.span`
  margin-right: 10px;
  font-size: 36px;
  font-weight: 600;
  background: linear-gradient(
    -30deg,
    #c89812 0%,
    #f8c40c 30%,
    #c89812 83%,
    #ffe68f 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  top: 3px;
  text-fill-color: transparent;
  @media (max-width: 991px) {
    font-size: 28px;
  }
`;
export const Count = styled.span`
  color: var(--font-color-emp);
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;
export const Text = styled.p`
  color: var(--font-color-main);
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;
`;
export const Address = styled(Text)`
  margin: 0;
`;

export const Bio = styled(Text)`
  margin-top: 10px;
  white-space: pre-wrap;
`;
export const Location = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
`;
export const PinIcon = styled(PinIc)`
  margin-right: 10px;
  margin-top: 2px;
  min-width: 13px;
`;
